import { DateTimeString } from "../../dateTypes.js";
import { OutputContentId, OutputId } from "../../idTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const CREATE_OUTPUT_CONTENT = createAppSessionEventDefinition({
  type: "CREATE_OUTPUT_CONTENT",
  logSafe: {
    outputContentId: true,
    outputId: true,
    createdDate: true,
    mimeType: true,
  },
  create: (payload: {
    outputContentId: OutputContentId;
    outputId: OutputId;
    createdDate: DateTimeString;
    mimeType: string;
  }) => payload,
  apply: (
    previousState,
    { createdDate, mimeType, outputContentId, outputId },
  ) => {
    const warnings: string[] = [];

    if (previousState.outputs[outputId] == null) {
      warnings.push(`Output not found: ${outputId}`);
    }

    if (previousState.outputContents[outputContentId] != null) {
      warnings.push(
        `Output content previously existed, overwriting: ${outputContentId}`,
      );
    }

    previousState.outputContents[outputContentId] = {
      id: outputContentId,
      outputId,
      createdDate,
      mimeType,
    };

    return { warnings };
  },
});
